import React, { useState } from 'react';

const ModerationModal = ({ isOpen, onClose, currentStatus, onStatusChange }) => {
  const [selectedStatus, setSelectedStatus] = useState('');
  const [notes, setNotes] = useState('');
  const [loading, setLoading] = useState(false);

  const statusOptions = [
    { 
      value: 'pending', 
      label: 'Pending Review', 
      icon: '⏳', 
      color: 'bg-yellow-900/30 text-yellow-400 border-yellow-800/50',
      hover: 'hover:bg-yellow-900/40 hover:border-yellow-700'
    },
    { 
      value: 'approved', 
      label: 'Approved', 
      icon: '✅', 
      color: 'bg-green-900/30 text-green-400 border-green-800/50',
      hover: 'hover:bg-green-900/40 hover:border-green-700'
    },
    { 
      value: 'rejected', 
      label: 'Rejected', 
      icon: '❌', 
      color: 'bg-red-900/30 text-red-400 border-red-800/50',
      hover: 'hover:bg-red-900/40 hover:border-red-700'
    },
    { 
      value: 'flagged', 
      label: 'Flagged', 
      icon: '🚩', 
      color: 'bg-[#ff660e]/20 text-[#ff660e] border-[#ff660e]/30',
      hover: 'hover:bg-[#ff660e]/30 hover:border-[#ff660e]/50'
    }
  ];

  if (!isOpen) return null;

  const handleSubmit = async () => {
    if (!selectedStatus) {
      alert('Please select a status');
      return;
    }

    setLoading(true);
    try {
      await onStatusChange(selectedStatus, notes);
      setSelectedStatus('');
      setNotes('');
    } catch (error) {
      console.error('Status change error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-gray-800 rounded-2xl w-full max-w-md border border-gray-700 shadow-2xl">
        <div className="p-6 border-b border-gray-700">
          <div className="flex items-center justify-between">
            <h3 className="text-xl font-bold text-white">Change Moderation Status</h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-white p-1 rounded-full hover:bg-gray-700 transition-colors"
            >
              ✕
            </button>
          </div>
          <p className="text-gray-400 text-sm mt-1">
            Current status: <span className="font-medium text-white capitalize">{currentStatus}</span>
          </p>
        </div>

        <div className="p-6">
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                Select New Status
              </label>
              <div className="grid grid-cols-2 gap-2">
                {statusOptions.map((option) => (
                  <button
                    key={option.value}
                    onClick={() => setSelectedStatus(option.value)}
                    className={`p-3 rounded-xl border-2 text-left transition-all duration-200 ${option.hover} ${
                      selectedStatus === option.value
                        ? 'ring-2 ring-offset-2 ring-[#ff660e]/50 border-[#ff660e] scale-[1.02]'
                        : `border-transparent ${option.color}`
                    }`}
                  >
                    <div className="flex items-center gap-2">
                      <span className="text-lg">{option.icon}</span>
                      <span className="font-medium">{option.label}</span>
                    </div>
                  </button>
                ))}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                Notes (Optional)
              </label>
              <textarea
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                placeholder="Add notes about this status change..."
                className="w-full p-3 bg-gray-700 border border-gray-600 rounded-xl focus:ring-2 focus:ring-[#ff660e] focus:border-transparent text-white placeholder-gray-500 transition-all"
                rows="3"
              />
            </div>

            <div className="flex gap-3 pt-4">
              <button
                onClick={onClose}
                className="flex-1 px-4 py-3 border border-gray-600 text-gray-300 rounded-xl font-medium hover:bg-gray-700 hover:text-white transition-all duration-200 hover:scale-[1.02]"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                disabled={!selectedStatus || loading}
                className="flex-1 px-4 py-3 rounded-xl font-medium text-white transition-all duration-200 hover:scale-[1.02] disabled:opacity-50 disabled:cursor-not-allowed bg-gradient-to-r from-[#ff660e] to-orange-500"
              >
                {loading ? (
                  <div className="flex items-center justify-center gap-2">
                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    <span>Updating...</span>
                  </div>
                ) : (
                  'Update Status'
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModerationModal;